<div class="flex justify-between items-center mb-4">
  <div class="text-xl text-gray-700 font-bold">
    @if (!assignPermission) {
      Perfil
    } @else {
      Gerenciar permissões do
      <span class="capitalize">{{ item.descricao }}</span>
    }
  </div>
  @if (assignPermission) {
    <button class="btn-icon" (click)="backProfile()">
      <mat-icon>keyboard_return</mat-icon>
    </button>
  }
</div>
@if (assignPermission) {
  <assign-permission [profile]="item" />
} @else {
  <div>
    @if (checkPermission('criar')) {
      <mat-card class="card-style">
        <profile-create (responseCreate)="uploadList()" />
      </mat-card>
    }
    <div class="mt-4">
      @if (checkPermission('pesquisar-paginado')) {
        <form-search [search]="inputSearch" (responseSearch)="search($event)" />
      }
      @if (!loading) {
        <div>
          <table-list-simple
            [dataSource]="itemsList"
            [columns]="columns"
            (selectItem)="editProfile($event)"
            (deleteItem)="deleteProfile($event)"
            (managerItem)="editPermission($event)"
          />
          @if (itemsList.length > 0) {
            <mat-paginator
              [length]="numberRows"
              [pageSize]="rows"
              [pageIndex]="page - 1"
              [pageSizeOptions]="[5, 10, 20, 30]"
              (page)="onPageEvent($event)"
            >
            </mat-paginator>
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
}
